import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './annuals.types';
import * as constants from './annuals.constants';

export const storeAnnual = generateStoreResourceAction<types.IAnnual>(constants.STORE_ANNUAL);
export const clearAnnual = generateClearResourceAction(constants.CLEAR_ANNUAL);
